import {
  BooleanField,
  BooleanInput,
  Create,
  CreateButton,
  DataTable,
  DateField,
  DateInput,
  DateTimeInput,
  Edit,
  EditButton,
  ExportButton,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "@/components/admin";
import { TopToolbar } from "../layout/TopToolbar";
import { HRStatusBadgeField } from "./HRStatusBadge";

export const ListActions = ({ label = "Create" }: { label?: string }) => (
  <TopToolbar className="flex items-center gap-2">
    <ExportButton />
    <CreateButton label={label} />
  </TopToolbar>
);

export const EditActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

export const NeutralBadge = HRStatusBadgeField;

export {
  BooleanField,
  BooleanInput,
  Create,
  DataTable,
  DateField,
  DateInput,
  DateTimeInput,
  Edit,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput
};

